/* Recipe V2 Client barrel export */

import { RecipeV2ClientMocked } from './recipeV2ClientMocked';

// Re-export types
export * from './recipeV2Types';

// Recipe V2 has no real backend yet — always use the in-code mocked client.
const recipeV2Client = new RecipeV2ClientMocked();

export { recipeV2Client, RecipeV2ClientMocked };
export type { IRecipeV2Client } from './IRecipeV2Client';
